import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOnHoldInvoiceReasonCodeQuickInfo extends Layout {
    panelOnHoldInvoiceReasonCode: Panel;
    sourceBackOfficeReasonCode: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxReasonText: Textbox;
}
